export default __webpack_public_path__ + "static/media/img.8494d873.svg";